import type { Technique } from '../types';
import { POISSON_SCATTER_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type PoissonScatterState } from './render';

export const poissonScatter: Technique<PoissonScatterState> = {
  id: 'poisson-scatter',
  name: 'Poisson-Streuung',
  category: 'packing',
  description: 'Gleichverteilte Elemente mit Mindestabstand, dichter nahe am Text.',
  params: POISSON_SCATTER_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
